/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_TitleInputs */

const en_us2_draft_title = /** @type {(inputs: Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New plan`)
};

const pt_br2_draft_title = /** @type {(inputs: Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo plano`)
};

const es_419_draft_title = /** @type {(inputs: Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo plan`)
};

const pt_pt2_draft_title = /** @type {(inputs: Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo plano`)
};

const fr_fr2_draft_title = /** @type {(inputs: Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau programme`)
};

const de_de2_draft_title = /** @type {(inputs: Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Plan`)
};

const it_it2_draft_title = /** @type {(inputs: Draft_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova scheda`)
};

/**
* | output |
* | --- |
* | "New plan" |
*
* @param {Draft_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_title = /** @type {((inputs?: Draft_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_title(inputs)
	if (locale === "es-419") return es_419_draft_title(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_title(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_title(inputs)
	if (locale === "de-DE") return de_de2_draft_title(inputs)
	if (locale === "it-IT") return it_it2_draft_title(inputs)
	return en_us2_draft_title(inputs)
});
export { draft_title as "draft.title" }